/* eslint eqeqeq: 0, no-param-reassign: 0 */
import { combineReducers } from "redux";
import { List } from "immutable";
import { CLOSE_POPUP } from "../constants";
import * as constants from "../constants/campaignList";
import { AdwCampaign } from "../records/campaigns";
import { moment } from "../utils";
import { ON_LOAD_CONFIG } from "../constants/config";

function isOpen(state = false, action) {
  if (action.type == CLOSE_POPUP) {
    return false;
  }

  if (
    action.type == constants.OPEN_ADW_CAMPAIGN_POPUP ||
    action.type == constants.ON_LOAD_ADW_CAMPAIGN
  ) {
    return true;
  }

  return state;
}

function campaign(state = new AdwCampaign(), action) {
  if (action.type === ON_LOAD_CONFIG && action.payload.MIN_CPC) {
    return state.set("cpc", action.payload.MIN_CPC);
  }
  if (action.type == constants.OPEN_ADW_CAMPAIGN_POPUP) {
    return new AdwCampaign({ id: action.campaignId });
  }
  if (action.type == constants.ON_LOAD_ADW_CAMPAIGN) {
    action.campaign.scheduler_hour = new List(action.campaign.scheduler_hour);
    action.campaign.scheduler_day = new List(action.campaign.scheduler_day);

    action.campaign.translation_start = action.campaign.translation_start
      ? moment(action.campaign.translation_start)
      : undefined;
    action.campaign.translation_stop = action.campaign.translation_stop
      ? moment(action.campaign.translation_stop)
      : undefined;

    return new AdwCampaign(action.campaign);
  }
  if (action.type == constants.SET_ADW_CAMPAIGN_FIELD) {
    return state.merge(action.payload);
  }
  if (
    action.type == constants.ON_SAVE_ADW_CAMPAIGN_SUCCESS ||
    action.type == constants.ON_CREATE_CAMPAIGN_SUCCESS
  ) {
    window.location.reload();
  }

  return state;
}

function errors(state = {}, action) {
  if (action.type == constants.ON_SAVE_ADW_CAMPAIGN_FAILD) {
    return action.errors;
  }
  if (action.type == CLOSE_POPUP) {
    return {};
  }
  return state;
}

export default combineReducers({
  isOpen,
  campaign,
  errors
});
